import { useContext, useEffect, useMemo, useRef } from 'react';
import { isEmpty } from 'lodash-es';
import { useFormState } from 'react-hook-form';
import { FormContext } from '../context';
function useIsValid(form) {
    const { form: contextForm } = useContext(FormContext);
    const internalForm = form ?? contextForm;
    const isMounted = useRef(false);
    if (!internalForm) {
        console.warn('Warning: useIsValid requires a form instance since it can not auto detect from context.');
    }
    const rhfForm = useMemo(() => internalForm?.getInternalRhfForm(), [internalForm]);
    const formState = useFormState({
        control: rhfForm.control,
    });
    useEffect(() => {
        const { isValid, errors } = formState;
        /* istanbul ignore else */
        if ((!isValid || !isEmpty(errors)) && !isMounted.current) {
            isMounted.current = true;
            /* istanbul ignore else */
            if (!isValid && isEmpty(errors)) {
                // trigger validate
                void rhfForm.trigger();
            }
        }
    }, [formState, rhfForm]);
    const { isValid, errors } = formState;
    return isValid && isEmpty(errors);
}
export default useIsValid;
